import JobByLocationWrapper from '../../wrapper/job-by-location/job-by-location'

const JobByLocationPage = (props) => <JobByLocationWrapper {...props} locations={props.locations} />
export default JobByLocationPage
